import type { BrowserCameraConfig } from './types';

export class CameraController {
  private readonly options: BrowserCameraConfig;
  private stream: MediaStream | null = null;

  constructor(options?: BrowserCameraConfig) {
    const defaultConstraints: MediaStreamConstraints = {
      video: {
        width: { ideal: 640 },
        height: { ideal: 480 },
        facingMode: 'user'
      }
    };
    this.options = {
      videoElement: options?.videoElement ?? null,
      constraints: options?.constraints ?? defaultConstraints
    };
  }

  async start(): Promise<MediaStream> {
    if (this.stream) return this.stream;
    if (!navigator.mediaDevices?.getUserMedia) {
      throw new Error('Camera API not available in this browser.');
    }
    const constraints = this.options.constraints ?? { video: true };
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    this.stream = stream;

    const video = this.options.videoElement;
    if (video) {
      video.srcObject = stream;
      try { await video.play(); } catch { /* ignore autoplay errors */ }
    }
    return stream;
  }

  stop(): void {
    if (this.stream) {
      this.stream.getTracks().forEach((t) => t.stop());
      this.stream = null;
    }
    const video = this.options.videoElement;
    if (video && video.srcObject) {
      video.srcObject = null;
    }
  }

  getStream(): MediaStream | null {
    return this.stream;
  }
}
